import { createContext, PropsWithChildren, useEffect, useState } from "react";
import { getConfiguration } from "../services/commonService";
import { useToast } from "../hooks/useToast";
import { ToastTypesList } from '../utils/constants';
import { Response } from "../types/common";
import { getCurrentCookiePolicy } from "../services/authService/authService";

export type ConfigData = {
    key: string,
    value: string,
}

type MinAndMaxBirthdateYears = {
    maxYear: number,
    minYear: number,
}

interface ConfigResponse {
    type: string;
    values: ConfigData[];
}

export interface ConfigContextProps {
    countryCodes?: ConfigData[],
    genders?: ConfigData[],
    minAndMaxBirthdateYears?: MinAndMaxBirthdateYears,
    hasNetworkError: boolean,
    setHasNetworkError: React.Dispatch<React.SetStateAction<boolean>>,
    cookiePolicyVersion?: string,
    cookiePolicyAdviceText: string,
}

const defaulValues: ConfigContextProps = {
    countryCodes: [],
    genders: [],
    minAndMaxBirthdateYears: {
        minYear: new Date().getFullYear() - 100,
        maxYear: new Date().getFullYear() - 18,
    },
    hasNetworkError: false,
    setHasNetworkError: () => { },
    cookiePolicyAdviceText: '',
}

export const ConfigContext = createContext(defaulValues);

export const ConfigProvider = ({ children }: PropsWithChildren) => {

    const [countryCodes, setCountryCodes] = useState<ConfigData[]>();
    const [genders, setGenders] = useState<ConfigData[]>();
    const [minAndMaxBirthdateYears, setMinAndMaxBirthdateYears] = useState<MinAndMaxBirthdateYears>();
    const [hasNetworkError, setHasNetworkError] = useState(false);
    const [cookiePolicyVersion, setCookiePolicyVersion] = useState<string>();
    const [cookiePolicyAdviceText, setCookiePolicyAdviceText] = useState('');

    const { showToast } = useToast();

    useEffect(() => {
        const fetchConfigs = async () => {
            try {
                const configResponse: Response<ConfigResponse[]> = await getConfiguration();
                if (configResponse.successful) {
                    setCountryCodes(configResponse.data?.find(e => e.type === 'phone_code')?.values)
                    setGenders(configResponse.data?.find(e => e.type === 'gender')?.values);

                    const minAndMaxUserAges = configResponse.data.find(e => e.type === 'age')!.values
                    const currentYear = new Date().getFullYear();
                    const maxYear = currentYear - Number(minAndMaxUserAges.find(e => e.key === 'min')!.value);
                    const minYear = currentYear - Number(minAndMaxUserAges.find(e => e.key === 'max')!.value);
                    setMinAndMaxBirthdateYears({ maxYear, minYear });
                } else {
                    throw configResponse.errors;
                }

                const cookiePolicyResp = await getCurrentCookiePolicy();
                if (cookiePolicyResp.successful) {
                    setCookiePolicyAdviceText(cookiePolicyResp.data.advice_text);
                    setCookiePolicyVersion(cookiePolicyResp.data.version);
                } else {
                    throw cookiePolicyResp.errors;
                }
            } catch (error) {
                console.error('error al cargar configuraciones', JSON.stringify(error))
                let msj = 'Error al cargar configuraciones';
                if (typeof error === 'object' &&
                    error !== null &&
                    'message' in error) {
                    msj = error.message as string;
                }
                showToast(ToastTypesList.ERROR, msj);
            }

        }

        fetchConfigs();
    }, []);

    return (
        <ConfigContext.Provider value={{ countryCodes, minAndMaxBirthdateYears, genders, hasNetworkError, setHasNetworkError, cookiePolicyAdviceText, cookiePolicyVersion }}>
            {children}
        </ConfigContext.Provider>
    )
}